import apiInstance from "./apiManager";

import { apiUsersUrls } from "config/endPoints";
import { configAuthToken } from "managers/usersDataManager";
import { refreshTokenOnce, getState, logoutAndPurge } from "managers/baseManager";

const apiSetupManager = (store) => {

  apiInstance
    .interceptors
    .request
    .use(
      (config) => {
        const token = getState()?.account?.token;
        if (token) {
          config.headers["Authorization"] = configAuthToken(token);
        }
        return config;
      },
      (error) => Promise.reject(error)
    );
    apiInstance
    .interceptors
    .response
    .use(
    (res) => res,
    async (err) => {
      const originalConfig = err.config;
      const account = getState()?.account;

      if (!account?.isLoggedIn) {
        logoutAndPurge();
        return Promise.reject(err);
      }

      if (originalConfig.url !== apiUsersUrls.API_AUTHENTICATE_URL && err.response) {
        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true;
          try {
            await refreshTokenOnce();
            return apiInstance(originalConfig);
          } catch (_error) {
            if (_error.response && _error.response.status === 403) {
              if (account?.isLoggedIn) {
                logoutAndPurge();
              }
              return Promise.reject(err);
            }
            return Promise.reject(_error);
          }
        } else if (err.response.status === 403) {
          if (account?.isLoggedIn) {
            logoutAndPurge();
          }
          return Promise.reject(err);
        }
      }
      return Promise.reject(err);
    }
  );
};

export default apiSetupManager;
